import { Component, OnDestroy, OnInit } from '@angular/core';
import { JobPost } from '../../../../jobs/models/job-post';
import { JobsStore } from '../../../../jobs/store/jobs-store.service';
import { UiStateStore } from '../../../../shared/store/ui-state-store.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-dashboard-job-invites',
  templateUrl: './dashboard-job-invites.component.html',
  styleUrls: ['./dashboard-job-invites.component.scss']
})
export class DashboardJobInvitesComponent implements OnInit, OnDestroy {

  searchText: string;
  accountId: string;
  jobPosts: JobPost[] = [];

  constructor(private uiState: UiStateStore,
    public jobsStore: JobsStore,
    public dataService: DataService) { }

  ngOnInit(): void {
    this.uiState.authenticatedUser.subscribe(user => {
      if (!user) {
        return;
      }
      this.accountId = user.accountId;

      this.dataService.getJobInvites(this.accountId).subscribe(jobPosts => { });
    });

    this.jobsStore.jobPosts.subscribe(jps => {
      if (!jps) {
        return;
      }

      this.jobPosts = jps;
    });
  }

  ngOnDestroy(): void {
    this.uiState.setSelectedJobId(null);
  }

  viewInvite(jobPostId: string, employerAccountId: string): void {
    window.open(`/view-job-interest/${jobPostId}/${employerAccountId}`, '_blank');
  }

  declineInvite(jobPostId): void {
    this.dataService.declineJobInvite(jobPostId, this.accountId).subscribe(r => {
      this.dataService.getJobInvites(this.accountId).subscribe(jobPosts => { });
    });
  }

}
